import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M18 13l-6 6","key":"svg-1"}],["path",{"d":"M6 13l6 6","key":"svg-2"}]]

const IconArrowDown = createReactComponent('outline', 'arrow-down', 'ArrowDown', __iconNode);

export default IconArrowDown;